import styled, { css } from "styled-components";
import tw from "twin.macro";

import { Body2 } from "../../Typography";

export const StyledOptionContentWrapper = styled.div`
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-items: center;
  height: 100%;
  flex-grow: 1;
`;

StyledOptionContentWrapper.displayName = "StyledOptionContentWrapper";

export const StyledOptionIndicator = styled.div<{ backgroundColor?: string }>`
  height: 24px;
  width: 24px;
  border-radius: 100%;
  margin-right: 8px;
  flex-shrink: 0;
  ${(props) =>
    props.backgroundColor &&
    !props.children &&
    css`
      background-color: ${props.backgroundColor};
    `}
`;

StyledOptionIndicator.displayName = "StyledOptionIndicator";

export const StyledOptionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
  color: currentColor;

  svg {
    width: 16px;
    height: 16px;
  }
`;

StyledOptionIcon.displayName = "StyledOptionIcon";

export const StyledOptionText = styled(Body2)<{ textColor?: string }>`
  ${tw`tw-truncate`}
  flex-grow: 1;
  line-height: 28px;
  padding-right: 10px;
  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}
`;

StyledOptionText.displayName = "StyledOptionText";

export const StyledAdditionalInfo = styled.span`
  margin: 0 0 0 5px;
  line-height: 18px;
  flex-shrink: 0;
`;

StyledAdditionalInfo.displayName = "StyledAdditionalInfo";
